export default __webpack_public_path__ + "static/media/DiodesImg.1fec0ad9.jpg";